import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=53399c81&scoped=true&lang=pug"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"
import style0 from "./Chip.vue?vue&type=style&index=0&id=53399c81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53399c81",
  null
  
)

export default component.exports